import React from 'react';

export function UhcBackfillFields({ fromDate, toDate, onFromDateChange, onToDateChange, disabled }) {
  const latestDate = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
  return <>
    <p className="text-sm text-gray-600">
      UHC uses the site's configured connection. Choose up to 366 days, ending before today (UTC).
      These are document search dates, not payment or service dates. The search may also return
      files from the preceding day to avoid missing files at the date boundary.
    </p>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label htmlFor="uhc-from-date" className="block text-sm font-medium text-gray-700 mb-2">Document search from date *</label>
        <input id="uhc-from-date" type="date" value={fromDate} max={latestDate} required disabled={disabled}
          onChange={event => onFromDateChange(event.target.value)} className="w-full p-2 border border-gray-300 rounded-md" />
      </div>
      <div>
        <label htmlFor="uhc-to-date" className="block text-sm font-medium text-gray-700 mb-2">Document search to date *</label>
        <input id="uhc-to-date" type="date" value={toDate} min={fromDate || undefined} max={latestDate} required disabled={disabled}
          onChange={event => onToDateChange(event.target.value)} className="w-full p-2 border border-gray-300 rounded-md" />
      </div>
    </div>
  </>;
}

export function UhcBackfillResult({ job }) {
  const result = job.result || {};
  const complete = job.status === 'COMPLETED' && result.coverage_complete === true && !result.ingestion_outcome_unknown;
  const stage = {
    validating: 'Checking site configuration', downloading: 'Downloading files',
    ingesting: 'Submitting a file', finished: 'Finishing', failed: 'Stopped',
  }[result.stage] || 'Waiting';
  const outcomeText = {
    no_data: 'No 835 files were returned for the searched dates.',
    duplicate_only: 'All retrieved files were already recorded for this site.',
    resumed_complete: 'The requested search windows were completed by the previous run.',
  }[result.outcome];
  return <div className="text-sm mt-2 text-gray-700">
    {result.scope && <p>Document search dates: {result.scope.from_date}–{result.scope.to_date}</p>}
    <p>{complete ? 'Finished' : stage} · {result.files_downloaded || 0} downloaded · {result.files_submitted || 0} submitted · {result.files_duplicate || 0} duplicates</p>
    <p>{result.completed_windows?.length || 0} search windows completed</p>
    {result.current_window && !complete && <p>Current search: {result.current_window.join('–')}</p>}
    {complete && <p>Collection complete. This confirms collection and submission outcomes; it does not confirm downstream posting.</p>}
    {complete && outcomeText && <p>{outcomeText}</p>}
    {['FAILED', 'CANCELLED'].includes(job.status) && <p>Collection is incomplete. Files already submitted are retained.</p>}
    {job.status === 'COMPLETED' && !complete && <p className="text-red-700">Collection completeness could not be confirmed. Review this job before retrying.</p>}
    {job.error_message && <p className="text-red-700">{job.error_message}</p>}
    {result.ingestion_outcome_unknown && <p className="text-red-700">A file's ingestion outcome is uncertain. Reconcile its processing task and file record before retrying.</p>}
  </div>;
}
